import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import UsageAnalytics from "../../components/Spark/Dashboard/UsageAnalytics";
import EnhancedChatList from "../../components/Spark/Dashboard/EnhancedChatList";
import UIStore from "../../store/uiStore";
import UserAuthStore from "../../store/userStore";
import { useDashboardListeners } from "../../services/ListenerManager/useDashboardListeners";
import { useGetSparks } from "../../api/queryHooks";
import DashPageHeader from "../../components/shared/DashPageHeader";

const SparksDash = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const orgId = UserAuthStore((state) => state.orgId);
  const user = UserAuthStore((state) => state.user);
  const { data: sparksData } = useGetSparks(orgId, user?.uid, {
    enabled: !!orgId && !!user?.uid,
  });
  const setShowSidebar = UIStore((state) => state.setShowSidebar);
  
  useDashboardListeners();

  const filteredChats = sparksData?.filter(chat =>
    chat.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    chat.last_message?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    chat.space_name?.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];

  const handleNewChat = () => {
    navigate("/chat");
    if (window.innerWidth < 940) setShowSidebar(false);
  };

  return (
    <div className="w-full">
      <Header type="spark-dashboard" />
      <div className="h-[calc(100vh-80px)] overflow-auto show-scrollbar">
        <div className="max-w-4xl px-6 mx-auto">
          {/* Header Section */}
          <DashPageHeader
            title="Creative Sparks"
            description="Personal AI conversations across multiple providers. Switch models seamlessly while preserving your conversation history. Reference team Spectras with #tags to access shared knowledge, and invoke Forge agents using @mentions for specialized tasks. Your flexible workspace for creative exploration and everyday productivity."
            action={{ label: "Spark", onClick: handleNewChat }}
          />

          {/* Usage Analytics */}
          <div className="mb-8">
            <UsageAnalytics chats={sparksData || []} />
          </div>

          {/* Divider */}
          <div className="border-t border-edge-gray-200 dark:border-edge-panel-border mb-6"></div>

          {/* Search */}
          <div className="mb-6">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-ink-gray-500 dark:text-ink-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <input
                type="text"
                placeholder="Search chats by title, message, or Spectra name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="photon-field w-full pl-11 pr-4 py-3.5 border border-edge-gray-200 dark:border-edge-panel-border rounded-2xl bg-fill-white dark:bg-fill-dialog-surface text-ink-ink dark:text-ink-white placeholder-ink-gray-500 dark:placeholder-ink-gray-400 focus:outline-none focus:ring-2 focus:ring-focus-primary dark:focus:ring-focus-accent focus:border-transparent transition-all duration-200"
              />
            </div>
          </div>

          {/* Chat List */}
          <div>
            <EnhancedChatList chats={filteredChats} searchQuery={searchQuery} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SparksDash;
